import { Component } from '@angular/core';
import {ViewportScroller} from "@angular/common";

@Component({
  selector: 'app-footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss']
})
export class FooterMenuComponent {

  constructor(private scroller: ViewportScroller) {}

  scrollTo(fragment: string): void {
    this.scroller.scrollToAnchor(fragment);
  }
}
